import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import "../../index.css";
import Card from "./CardInd";
import Gift from "./Gift";
import { BACKEND_URL } from "../../consts";

const Industries = ({data}) => {

  const [data1, setData1] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BACKEND_URL}/api/v1/block/industriesall`)
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const fetchData = await response.json();
                setData1(fetchData);
            } catch (error) {
                console.log('ошибка');
            } finally {
                console.log('готово');
            }
        };
  
        fetchData();
    }, []);

    console.log('ДАТА 1 ' + data1)



  return (
    <>
      <div style={{backgroundColor:`${data.bg_color}`}} className={`min-h-screen w-[98%] mt-8 mx-auto px-2 lg:px-8 py-4 lg:py-8 rounded-3xl flex flex-col leading-tight font-manrope`}>
        <div className="xs:mb-8 mb-8 h-fit text-left flex xs:flex-row flex-row-reverse justify-around">
          <div className="mt-auto w-fit">
            <img src={data.header.image} alt="no image" className="xs:h-12 xs:w-12 h-8 w-8"/>
          </div>
          <div className="w-fit">
            <div className="xs:ml-[10%] mb-4">
              <h1 style={{color:`${data.header.text_color_2}`}} className={`lg:text-[40px] xs:text-[36px] text-[28px] font-bold block xs:hidden`}>
                {data.header.title_text_xs}
              </h1>
              <h1 style={{color:`${data.header.text_color_2}`}} className={`lg:text-[40px] xs:text-[36px] text-[28px] font-bold hidden xs:block`}>
                {data.header.title_text_lg}
              </h1>
            </div>
            <div className="flex flex-row justify-between lg:ml-[48%] xs:ml-[10%]">
              <p style={{color:`${data.header.text_color_2}`}} className={`lg:text-[24px] xs:text-[20px] text-[14px] block xs:hidden`}>
                {data.header.description_text_xs}
              </p>
              <p className="text-base hidden xs:block">
                <span style={{color:`${data.header.text_color_1}`}}>
                  {data.header.description_text_lg_1}{' '}
                </span>
                <span style={{color:`${data.header.text_color_2}`}}>
                  {data.header.description_text_lg_2}
                </span>
              </p>
            </div>
          </div>
          
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 auto-rows-fr gap-6">
 
          {data1.map((card,index) => (
            <Card
              key={index}
              title={card.payload.bigcard.title}
              description={card.payload.bigcard.description.text}
              image={card.payload.bigcard.bg}
              onClick={() => navigate(`/industries/${card.id}`)}
            />
          ))}
          <Gift
            title={data.gift.title}
            description={data.gift.description}
            gift={data.gift.gift}
            bg_color={data.gift.bg_color}
            text_color={data.gift.text_color}
            div1_color={data.gift.div1_color}
            button_bg={data.gift.button_bg}
            btn_hover_bg={data.gift.btn_hover_bg}
            btn_active_bg={data.gift.btn_active_bg}
            img_url={data.gift.img_url}
            img={data.gift.img}
            onClick={() => alert("Получить подарок")}
          />
        </div>
      </div>
      </>
  )
}

export default Industries;